import { ComponentWithOwnLabel } from 'Components/Core/types';
import { InterfaceConnectionPromptIssuer } from 'Components/Equipment/Interfacing';
import EquipmentTypes from '../../../../Equipment/equipmentTypes';
import { IListDropdownProps, ListDropdown } from '../../../../List/ListDropdown';
import { IWorksheetEquipmentLabelProps, WorksheetEquipmentLabel } from '../../WorksheetEquipment';

export interface IWorksheetEquipmentDropdownProps extends IListDropdownProps {
  id?: string;
  maxResults?: number;
  value?: any;
  defaultValue?: any;
  worksheetId?: any;
  equipmentType?: string;
  onChange?: (event?: any) => void;
  label?: string;
  placeholder?: string;
  queryParams?: any;
}

// Equipment dropdown for selecting list items searched by worksheet id
// Will hopefully be replaced with a search based on location after QP-3849
// Note: Equipment values come in and are saved as Id/Code pairs, so we need to parse label->Code and value->Id
const WorksheetEquipmentDropdown: ComponentWithOwnLabel<
  IWorksheetEquipmentDropdownProps,
  IWorksheetEquipmentLabelProps
> = ({
  id = undefined,
  maxResults = 20,
  value = null,
  defaultValue = null,
  worksheetId: availableForTestId = undefined,
  equipmentType,
  onChange = undefined,
  label = undefined,
  placeholder = 'Select equipment...',
  queryParams = undefined,
  disabled,
  ...otherProps
}) => {
  if (!equipmentType)
    throw new Error('WorksheetEquipmentDropdown components require an equipmentType to be specified.');
  const equipmentOnChange = (evt: any) => {
    evt.data.value = evt.data.value === null ? null : { Id: evt.data.value.value, Code: evt.data.value.label };
    onChange?.(evt);
  };

  const endpoint = EquipmentTypes[equipmentType]?.endpoint ?? 'list.equipment';

  return (
    <div className="WorksheetEquipmentDropdown">
      <InterfaceConnectionPromptIssuer equipment={value} equipmentType={equipmentType} disabled={disabled} />
      <ListDropdown
        {...otherProps}
        disabled={disabled}
        id={id}
        placeholder={placeholder}
        endpoint={endpoint}
        onChange={equipmentOnChange}
        queryParams={{ ...queryParams, equipmentType, availableForTestId, limit: maxResults }}
        value={value && (value.Id || value.Code) ? { value: value.Id, label: value.Code } : null}
        defaultValue={{ value: defaultValue && defaultValue.Id, label: defaultValue && defaultValue.Code }}
        maxResults={maxResults}
      />
    </div>
  );
};

WorksheetEquipmentDropdown.Label = WorksheetEquipmentLabel;

export { WorksheetEquipmentDropdown };
export default WorksheetEquipmentDropdown;
